import { render, staticRenderFns } from "./ResultCheckoffs.vue?vue&type=template&id=dc10e986&"
import script from "./ResultCheckoffs.vue?vue&type=script&lang=js&"
export * from "./ResultCheckoffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports